import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-45ff46a9"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "usersTableContainer" }
const _hoisted_2 = { class: "usersTableContainer__header" }
const _hoisted_3 = { class: "usersTableContainer__body" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createElementVNode("th", null, "Registro"),
  /*#__PURE__*/_createElementVNode("th", null, "Nombre"),
  /*#__PURE__*/_createElementVNode("th", null, "Perfil"),
  /*#__PURE__*/_createElementVNode("th", null, "Ocupación"),
  /*#__PURE__*/_createElementVNode("th", null, "Empresa"),
  /*#__PURE__*/_createElementVNode("th", null, "Editar"),
  /*#__PURE__*/_createElementVNode("th", null, "Eliminar")
], -1))
const _hoisted_5 = ["onClick"]
const _hoisted_6 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ModalCharging = _resolveComponent("ModalCharging")!
  const _component_HeaderApp = _resolveComponent("HeaderApp")!
  const _component_UserForm = _resolveComponent("UserForm")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_ModalCharging, { open: _ctx.isLoading }, null, 8, ["open"]),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_HeaderApp, { "header-type": 'management' })
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("table", null, [
        _hoisted_4,
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.users, (user, index) => {
          return (_openBlock(), _createElementBlock("tr", {
            key: user.id
          }, [
            _createElementVNode("td", null, _toDisplayString(index), 1),
            _createElementVNode("td", null, _toDisplayString(`${user.first_name} ${user.last_name}`), 1),
            _createElementVNode("td", null, _toDisplayString(user.profile.type), 1),
            _createElementVNode("td", null, _toDisplayString(user.profesional_headline), 1),
            _createElementVNode("td", null, _toDisplayString(user.enterprise.name), 1),
            _createElementVNode("td", null, [
              _createElementVNode("span", {
                class: "material-symbols-outlined edit",
                onClick: ($event: any) => (_ctx.manageUser(user))
              }, "edit", 8, _hoisted_5)
            ]),
            _createElementVNode("td", null, [
              _createElementVNode("span", {
                class: "material-symbols-outlined delete",
                onClick: ($event: any) => (_ctx.disableUser(user))
              }, " account_circle_off ", 8, _hoisted_6)
            ])
          ]))
        }), 128))
      ]),
      _withDirectives(_createVNode(_component_UserForm, {
        "used-for": 'management',
        "user-management-active": _ctx.activeUserManagement,
        userToManage: _ctx.pickedUser,
        onCancelUserManagement: _ctx.cancelUserManagement
      }, null, 8, ["user-management-active", "userToManage", "onCancelUserManagement"]), [
        [_vShow, _ctx.activeUserManagement]
      ])
    ])
  ]))
}